//
import store from '../store'
export function hasPermission(permission) {

  let isExist = false;
  let mybtns = store.getters.mybtns
  if (mybtns === null || mybtns === undefined){
    isExist = false
    return isExist
  }

  if (mybtns.indexOf(permission) > -1){
    isExist = true
    return isExist
  }else {
    isExist = false
    return isExist
  }

  return false
}



// WEBPACK FOOTER //
// ./src/utils/hasPermission.js